import { Box, Flex, Image } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Color } from 'src/theme/color';
import { FormValues } from '../../../formConfig';

export interface IPlatform {
	name: string;
	value: string;
	icon: string;
	soon?: boolean;
}

const PlatformIcon = ({ platform, active, onClick }: { platform: IPlatform; active: boolean; onClick: () => void }) => {
	const { t } = useTranslation();
	return (
		<Flex
			flexDir="column"
			gap="20px"
			align="Center"
		>
			<Flex
				onClick={platform.soon ? () => {} : onClick}
				cursor={platform.soon ? 'default' : 'pointer'}
				border="1px solid"
				borderRadius="4px"
				bg={active ? Color.HASHUP : Color.GRAY_4}
				borderColor={active ? Color.HASHUP : Color.GRAY_1}
				alignItems="center"
				justify="center"
				position="relative"
				opacity={platform.soon ? '0.5' : '1'}
				boxSize="170px"
			>
				{active && (
					<Box
						position="absolute"
						left="0"
						right="0"
						w="100%"
						h="100%"
						bg={Color.HASHUP}
						filter="blur(10px)"
						opacity="0.7"
						zIndex="-1"
					/>
				)}
				<Image
					src={platform.icon}
					pointerEvents="none"
					w="90px"
				/>
			</Flex>
			<Box>{t(`${platform.name}`)}</Box>
		</Flex>
	);
};

export const PlatformSelect = ({ name, platforms }: { name: string; platforms: IPlatform[] }) => {
	const { setFieldValue, values } = useFormikContext();
	const [selectedPlatforms, setSelectedPlatforms] = useState<any[]>([]);

	useEffect(() => {
		setSelectedPlatforms((values as any)[name]);
	}, []);

	const clickPlatform = (value: string) => {
		if (selectedPlatforms.includes(value)) {
			setSelectedPlatforms(state => state.filter(state => state != value));
		} else {
			setSelectedPlatforms(state => [...state, value]);
		}
	};

	useEffect(() => {
		setFieldValue(name, selectedPlatforms);
	}, [selectedPlatforms]);

	const { t } = useTranslation();

	return (
		<Flex
			gap="40px"
			mt="20px"
		>
			{platforms.map(platform => {
				return (
					<PlatformIcon
						onClick={() => clickPlatform(platform.value)}
						platform={platform}
						active={selectedPlatforms.includes(platform.value)}
						key={platform.value}
					/>
				);
			})}
		</Flex>
	);
};
